import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { JurisdictionTypeEnum } from '@zaoblako/shared/modules/client/enums/jurisdiction-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link JurisdictionTypeEnum} enumeration values */
export const JurisdictionTypeEnumI18n: EnumI18nInterface<JurisdictionTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [JurisdictionTypeEnum.RUSSIAN_FEDERATION]: 'Российская Федерация',
    [JurisdictionTypeEnum.FOREIGN]: 'Иностранная',
  },
  [I18nLocalesEnum.EN_US]: {
    [JurisdictionTypeEnum.RUSSIAN_FEDERATION]: 'Russian Federation',
    [JurisdictionTypeEnum.FOREIGN]: 'Foreign',
  },
};
